import type { CircleCommentResponse } from "@consistency-circle/shared";

import { formatRelativeTime } from "../utils";

interface CommentRowProps {
  readonly comment: CircleCommentResponse;
}

export function CommentRow({ comment }: CommentRowProps) {
  return (
    <div className="rounded-xl border border-border bg-card px-4 py-3 space-y-0.5">
      <p className="text-xs font-medium text-muted-foreground">
        {comment.authorDisplayName}
        {comment.targetDisplayName ? ` -> ${comment.targetDisplayName}` : ""}
      </p>
      <p className="text-sm">{comment.message}</p>
      <p className="text-xs text-muted-foreground">{formatRelativeTime(comment.createdAt)}</p>
    </div>
  );
}
